module.exports = __webpack_public_path__ + "static/media/toggle.f8b5dccf.svg";